import React from 'react'
import styled from 'styled-components'

const StyledButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  & > a {
    margin-bottom: 16px;
  }

  ${({ theme }) => theme.media.tablet} {
    flex-direction: row;

    & > a {
      margin-right: 16px;
      
      &:last-child {
        margin-right: 0;
      }
    }
  }
`

const ButtonGroup = ({ children }) => {
  return <StyledButtonGroup>{children}</StyledButtonGroup>
}

export default ButtonGroup